<template>
  <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
    <div class="flex-shrink-0">
      <img class="h-48 w-full object-cover" :src="course.image" alt="" />
    </div>
    <div class="flex-1 bg-white p-6 flex flex-col justify-between">
      <div class="flex-1">
        <p class="text-sm font-medium text-cyan-600">
          <!-- <a href="#" class="hover:underline"></a> -->
          {{ course.department.name }}
        </p>
        <router-link
          :to="{ name: 'course_show', params: { id: course.id } }"
          class="block mt-2"
        >
          <p class="text-xl font-semibold text-gray-900">
            {{ course.name }}
          </p>
          <div class="mt-2">
            <span
              v-if="course.status_id == 1"
              class="rounded-full bg-indigo-400 py-1 px-4 text-white"
              >в работе</span
            >
            <span
              v-if="course.status_id == 5"
              class="rounded-full bg-green-400 py-1 px-4 text-white"
              >завершён</span
            >
          </div>
          <div class="flex mt-2">
            <div
              v-for="index in 5"
              :key="index"
              class="flex items-center mt-2 mb-4"
            >
              <svg
                :class="[
                  'mx-1 w-4 h-4 fill-current',
                  course.rating >= index ? 'text-yellow-500' : 'text-gray-400',
                ]"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"
                />
              </svg>
            </div>
          </div>

          <p class="mt-3 text-base text-gray-500">
            {{ course.description }}
          </p>
        </router-link>
      </div>
      <div class="mt-6 flex items-center">
        <div class="flex text-sm text-gray-500">
          <span class="flex items-center py-2 text-sm text-gray-700">
            <svg
              class="mr-3 h-5 w-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {{ course.duration }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-4">
      <div class="card mx-auto">
        <img :src="course.image" alt="" class="card-img-top" />
        <div class="card-body d-flex flex-column">
          <div class="card__header--secondary mb-1">
            {{ course.department.name }}
          </div>
          <div class="d-inline-flex">
            <span v-if="course.status_id == 1" class="badge badge-info"
              >в работе</span
            >
            <span v-if="course.status_id == 5" class="badge badge-success"
              >завершён</span
            >
          </div>
          <div class="card__header--primary mb-1">{{ course.name }}</div>
          <div class="card__rating">

            <span :class="{ 'card__rating--filled': course.rating >= 1 }"
              >☆</span
            >
            <span :class="{ 'card__rating--filled': course.rating >= 2 }"
              >☆</span
            >
            <span :class="{ 'card__rating--filled': course.rating >= 3 }"
              >☆</span
            >
            <span :class="{ 'card__rating--filled': course.rating >= 4 }"
              >☆</span
            >
            <span :class="{ 'card__rating--filled': course.rating >= 5 }"
              >☆</span
            >
          </div>
          <p>
            {{ course.description }}
          </p>
          <div class="mt-auto">
            <div class="mb-3 d-flex card__icon-container">
              <div>
                <img src="/images/clock.svg" alt="" class="card__icon" />
               &nbsp;
                <span>{{ course.duration }}</span>
              </div>
            </div>
            <router-link
              class="btn card__button"
              :to="{ name: 'course_show', params: { id: course.id } }"
              >Перейти к курсу</router-link
            >&nbsp;
          </div>
        </div>
      </div>
    </div> -->
</template>


<script>
export default {
  data() {
    return {};
  },
  props: {
    course: Object,
  },
};
</script>


